const QUEUE_KEY = "pos_offline_queue";

export function getOfflineQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
  } catch (e) {
    return [];
  }
}

export function enqueueOfflineSale(payload) {
  const queue = getOfflineQueue();
  queue.push({
    id: `offline-${Date.now()}`,
    payload,
    createdAt: new Date().toISOString(),
  });
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  return queue.length;
}

export function clearOfflineQueue() {
  localStorage.removeItem(QUEUE_KEY);
}

export async function flushOfflineQueue(apiPost) {
  const queue = getOfflineQueue();
  if (!queue.length) return { synced: 0, failed: 0 };

  let synced = 0;
  let failed = 0;
  const remaining = [];

  for (const item of queue) {
    try {
      await apiPost("sales", item.payload);
      synced += 1;
    } catch (e) {
      failed += 1;
      remaining.push(item);
    }
  }

  localStorage.setItem(QUEUE_KEY, JSON.stringify(remaining));

  return { synced, failed, remaining: remaining.length };
}

export function isOnline() {
  return typeof navigator !== "undefined" ? navigator.onLine : true;
}
